import React, { useEffect, useState } from "react";
import Filters from "./Filters";
import { ACTIONS, APPROVAL_PENDING, DOWNLOAD, fieldKeys, getList, getSurveyForms, handleAction, reassignDefaultPayload, REDOWNLOAD } from "./helper";
import DataTable from "./DataTable";
import { toast } from "react-toastify";
import LoadingPage from "../../reusableComponents/loader/loadingPage";
import { Button, Col, Row } from "react-bootstrap";
import FieldSurveyRequest from "../fieldSurveyRequest";
import { submitBulkSurveyAction } from "../bulkSurvey/bulkApiHelper";
import { getFromDecreaptLocalStorage } from "../../utilFunctions";
import { CLAIMS_HANDLER, VENDOR_MANAGER } from "../../consts";

const ListPage = ({ productNames }) => {
    const [data, setData] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [notifyResurveyPayload, setNotifyResurveyPayload] = useState(null);
    const [selectedData, setSelectedData] = useState([])
    const [actionItem, setActionItem] = useState(null)
    const roleDataCookie = getFromDecreaptLocalStorage("roleData")
    const vendorManagerDetails = getFromDecreaptLocalStorage("vendorManagerDetails");
    const isVendorManager = roleDataCookie?.roleName === VENDOR_MANAGER
    const isClaimsHandler = roleDataCookie?.roleName === CLAIMS_HANDLER
    const isAdmin = roleDataCookie?.roleName === "Admin";
    const defaultFieldValues = {
        [fieldKeys.season]: "",
        [fieldKeys.year]: "",
        [fieldKeys.product]: null,
        [fieldKeys.state]: "",
        [fieldKeys.district]: "",
        [fieldKeys.mandal]: "",
        [fieldKeys.village]: "",
        [fieldKeys.surveyStatus]: "",
        [fieldKeys.farmerId]: "",
        [fieldKeys.farmerName]: "",
        [fieldKeys.policyNumber]: "",
        [fieldKeys.surveyId]: "",
        [fieldKeys.surveyorName]: "",
        [fieldKeys.startDate]: "",
        [fieldKeys.endDate]: "",
        [fieldKeys.downloadStatus]: null,
        [fieldKeys.pageNo]: 1,
        [fieldKeys.count]: 10
    };
    const [fieldValues, setFieldValues] = useState(defaultFieldValues)

    const setValue = (key, value) => {
        setFieldValues((prev) => ({
            ...prev,
            [key]: value,
        }));
    };
    const handleSearch = async (page, size) => {
        setActionItem(fieldValues[fieldKeys.downloadStatus]?.value || null)
        getList(fieldValues, toast, setData, setIsLoading, page, size);
    }
    const handleReset = () => {
        setFieldValues(defaultFieldValues);
        setData(null)
    }

    const submitBulkReSurvey = async (notifyPayload) => {
        let refilteredData = selectedData
            .map((data) => ({
                claimIntimationNumber: data.claimNo,
                fieldSurveyNumber: data.surveyNumber,
            }));
        notifyPayload.claims = refilteredData;

        setIsLoading(true);
        try {
            await submitBulkSurveyAction(
                notifyPayload,
                roleDataCookie,
                refilteredData,
                true,
            );
            setSelectedData([])
            handleSearch()
            setIsLoading(false);
            setNotifyResurveyPayload({...reassignDefaultPayload, vendorName: isVendorManager ? vendorManagerDetails?.vendorName: ""})

        } catch (error) {
            console.error('Error in submitBulkReSurvey:', error);
            setIsLoading(false);
            setNotifyResurveyPayload({...reassignDefaultPayload, vendorName: isVendorManager ? vendorManagerDetails?.vendorName: ""})
        }
    };

    const handlePageOrSizeChange = (page, count) => {
        if(String(page)) {
            setValue(fieldKeys.pageNo, page)
        }
        if(String(count)) {
            setValue(fieldKeys.count, count)
        }
        handleSearch(page,count)
    }

    useEffect(()=> {
        setNotifyResurveyPayload({...reassignDefaultPayload, vendorName: isVendorManager ? vendorManagerDetails?.vendorName: ""})
        
    },[])

    // const handleAction = async(action) => {
    //     const isDownloaded = await getSurveyForms(selectedData.map(data => data.surveyNumber), setIsLoading, action)
    //     if(isDownloaded) {
    //         if(action === ACTIONS.DOWNLOAD) {
    //             toast.success("Survey form downloaded successfully");
    //         } else if (action === ACTIONS.APPROVE) {
    //             toast.success("Approved")
    //         } else if(action === ACTIONS.REDOWNLOAD) {
    //             toast.error("Sent for approval")
    //         }
    //         setSelectedData([])
    //     }
    // }

    return (
        <section className="p-4">
            <h1 className="headerclaim">Survey Management</h1>
            <hr />
            <Filters setValue={setValue} fieldValues={fieldValues} productNames={productNames} handleSearch={handleSearch} handleReset={handleReset} setData={setData}/>
            <div className="mt-1">
                    <>
                        {data?.list?.length ? (
                            <Row>
                                <Col xs={10}>
                                    <h2 className="heading_h2">
                                        Search Results ({data?.totalRecords})
                                    </h2>
                                </Col>
                            <Col xs={2}>
                            <div className="float-end mt-3">
                                {(isAdmin && (actionItem) || actionItem === DOWNLOAD ) && (!isClaimsHandler)? (
                                    <Button
                                        className="btn btn-success" 
                                        disabled={!selectedData?.length}
                                        onClick={async() => {
                                            await handleAction(ACTIONS.DOWNLOAD, selectedData, setSelectedData, setIsLoading);
                                            await handleSearch();
                                        }}
                                    >
                                        Download
                                    </Button>
                                ) : (actionItem === REDOWNLOAD && !isClaimsHandler) ? (
                                    <Button
                                        className="btn btn-success"
                                        disabled={!selectedData?.length}
                                        onClick={async () => {
                                            await handleAction(ACTIONS.REDOWNLOAD, selectedData, setSelectedData, setIsLoading);
                                            await handleSearch();
                                        }}
                                    >
                                        Re-download
                                    </Button>
                                ) : (actionItem === APPROVAL_PENDING && isClaimsHandler) ? (
                                    <Button
                                        className="btn btn-success"
                                        disabled={!selectedData?.length}
                                         onClick={async () => {
                                            await handleAction(ACTIONS.APPROVE, selectedData, setSelectedData, setIsLoading);
                                            await handleSearch();
                                        }}
                                    >
                                        Approve
                                    </Button>
                                ) : !actionItem ? (
                                    <FieldSurveyRequest
                                        notifyPayload={notifyResurveyPayload}
                                        setNotifyPayload={setNotifyResurveyPayload}
                                        isBulkReSurveyRequest={true}
                                        submitBulkReSurvey={submitBulkReSurvey}
                                        bulkReSurveyLoading={isLoading}
                                        setBulkReSurveyLoading={setIsLoading}
                                        disableRequest={!selectedData?.length}
                                        claimDetailCookie={{}}
                                        // surveyorName={fieldResurveyData[0].surveyor}
                                        requestButtonText={'Reassign'}
                                        hideVendorName={roleDataCookie?.roleName === VENDOR_MANAGER}
                                        vendorId={roleDataCookie?.roleName === VENDOR_MANAGER ? vendorManagerDetails?.vendorId : undefined}
                                    />
                                ) : ""}
                                </div>
                            </Col>
                                
                            </Row>
                        ): ''}

                        <DataTable data={data?.list} selectedData={selectedData} setSelectedData={setSelectedData} totalRecordsCount={data?.totalRecords} handlePageOrSizeChange={handlePageOrSizeChange} getList={handleSearch} setIsLoading={setIsLoading} actionItem={actionItem}/>
                    </>
            </div>
            {isLoading && (<LoadingPage  kshemaLoader/>)}
        </section>
    )
}

export default ListPage;